import { render } from "./RuiEyeClosed.vue?vue&type=template&id=c7019546"
const script = {}
script.render = render

export default script